<template>
  <div class="login">
    <section class="form_container" v-show="loginShow">
      <div class="manage_tip">
          <span class="title">管理后台</span>
      </div>
      <el-form :model="loginUser" status-icon :rules="rules" ref="loginForm" class="loginForm">
        <el-form-item prop="name">
          <el-input v-model="loginUser.name" autocomplete="off" placeholder="请输入用户名"></el-input>
        </el-form-item>
        <el-form-item prop="pass">
          <el-input type="password" v-model="loginUser.pass" autocomplete="off" placeholder="请输入密码" @keyup.enter.native="submitForm('loginForm')"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('loginForm')" class="submit_btn">登录</el-button>
          <div class="dd_login">
            <img src="/static/dingtalk.png" width="30" alt="" @click="ddFrameLogin">
            <img src="/static/qywx.jpg" width="30" alt="" @click="qwLogin">
          </div>
        </el-form-item>
      </el-form>
    </section>
    <!-- <div class="ddLogin-back" v-show="ddLoginShow || qwLoginShow" @click="closeDdLogin"></div> -->
    <div v-show="ddLoginShow" class="codeLogin_box">
      <div class="ddLogin">
        <div class="ddLogin-header">
          <img style="margin-right: 6px;" src="/static/dingtalk.png" width="16" height="16">
          <span style="font-size: 16px;">钉钉扫码登录</span>
        </div>
        <div id="ddLogin"></div>
        <div class="ddLogin-bottom">请使用钉钉扫描二维码登录</div>
      </div>
      <div class="otherLogin">
        <span style="margin-right: .2rem; color: rgb(87, 135, 255)" @click="handelPassLogin">密码登录</span>
        <img src="/static/qywx.jpg" width="28" alt="" @click="qwLogin">
      </div>
    </div>
    <div class="codeLogin_box" v-show="qwLoginShow">
      <div id="ww_login"></div>
      <div class="otherLogin">
        <span style="margin-right: .2rem; color: rgb(87, 135, 255)" @click="handelPassLogin">密码登录</span>
        <img src="/static/dingtalk.png" width="28" alt="" @click="ddFrameLogin">
      </div>
    </div>
  </div>
</template>

<script>
import * as ww from '@wecom/jssdk'
export default {
  name: 'Login',
  data () {
    return {
      loginShow: false,
      ddLoginShow: false,
      qwLoginShow: true,
      loginUser: {
        name: '',
        pass: ''
      },
      rules: {
        name: [{
          required: true,
          message: '用户名不能为空',
          trigger: 'blur'
        }, {
          min: 2,
          max: 30,
          message: '长度在2-30个字符之间'
        }],
        pass: [{
          required: true,
          message: '密码不能为空',
          trigger: 'blur'
        }, {
          min: 6,
          max: 30,
          message: '长度在6-30个字符之间'
        }]
      },
      qwCnf: null,
      qwAgentConf: null,
      ddAuthing: false
    }
  },
  methods: {
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$axios.post('/api/admin/login', {
            name: this.loginUser.name,
            pwd: this.loginUser.pass
          })
            .then(res => {
              const { data } = res
              if (data.code === 0) {
                const { token } = data.data
                this.next(token)
              } else {
                this.$message.error(data.msg)
              }
            })
        }
      })
    },
    ddLoginInit () {
      const location = window.location
      let _that = this
      const ddTeest = window.DTFrameLogin(
        {
          id: 'ddLogin',
          width: 320,
          height: 288
        },
        {
          redirect_uri: encodeURIComponent(`${location.protocol}//${location.host}${this.$route.fullPath}`),
          client_id: 'dingicrl2wiiwammf0kv',
          scope: 'openid',
          response_type: 'code',
          state: 'qyh_login',
          prompt: 'consent'
        },
        (loginResult) => {
          const {redirectUrl, authCode, state} = loginResult
          if (_that.ddAuthing) return
          _that.ddAuthing = true
          if (state === 'qyh_login') {
            _that.ddLoginCode(authCode)
          }
        },
        (errorMsg) => {
          alert(`Login Error: ${errorMsg}`)
        }
      )
      console.log(ddTeest)
    },
    ddFrameLogin () {
      this.ddLoginShow = true
      this.loginShow = false
      this.qwLoginShow = false
      this.ddLoginInit()
    },
    handelPassLogin () {
      this.ddLoginShow = false
      this.qwLoginShow = false
      this.loginShow = true
    },
    ddLoginCode (code) {
      this.$axios.post('/api/admin/ddLogin', { code })
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            const { token } = data.data
            this.next(token)
          } else {
            this.ddAuthing = false
            this.handelPassLogin()
            this.$message.error(data.msg)
          }
        })
    },
    qwInit () {
      const location = window.location
      let _that = this
      const wwLogin = ww.createWWLoginPanel({
        el: '#ww_login',
        params: {
          login_type: 'CorpApp',
          appid: 'ww5e54fc9b3c32d2ab',
          agentid: '1000049',
          redirect_uri: `${location.protocol}//${location.host}`,
          state: 'qyh',
          redirect_type: 'callback',
          panel_size: 'small'
        },
        onCheckWeComLogin ({ isWeComLogin }) {
          console.log('企业微信', isWeComLogin)
        },
        onLoginSuccess ({ code }) {
          console.log(code)
          _that.qwLoginCode(code)
        },
        onLoginFail (err) {
          console.log(err)
        }
      })
    },
    qwLogin () {
      this.qwLoginShow = true
      this.loginShow = false
      this.ddLoginShow = false
      // var elements = window.document.getElementById('ww_login')
      // var iframe = elements.querySelector('iframe')
      // var nuxtElement = iframe.contentWindow.document.getElementById('__nuxt')
      // console.log(nuxtElement)
    },
    qwLoginCode (code) {
      this.$axios.post('/api/admin/qwLogin', { code })
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            const { token } = data.data
            this.next(token)
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    next (token) {
      localStorage.token = token
      localStorage.historyRoute ? this.$router.push(localStorage.historyRoute) : this.$router.push('/')
    }
  },
  mounted () {
    // this.ddLoginInit()
    this.qwInit()
  }
}
</script>

<style lang="stylus" scoped>
  .codeLogin_box
    position: fixed
    top: 40%
    left: 51.5%
    margin-top: -113.5px
    margin-left: -222px
    background-color: #fff
    z-index: 99999
    .otherLogin
      padding: .2rem
      text-align: right
      span, img
        cursor: pointer
  .ddLogin-back
    width: 100%
    height: 100%
    background: #000
    opacity: 0.5
    position: fixed
    left: 0
    top: 0
    z-index: 99998
  .dd_login
    text-align: right
    img
      cursor: pointer
  #ddLogin
    width: 320px
  .ddLogin,#ww_login
    // position: fixed
    // top: 40%
    // left: 51.5%
    width: 320px
    // margin-top: -113.5px
    // margin-left: -222px
    background: #fff
    // z-index: 99999
  .ddLogin-header
    display: flex
    justify-content: center
    padding-top: 40px
  .ddLogin-bottom
    text-align: center
    padding-bottom: 20px
    color: #878f95
    font-weight: 400
  .login >>> .el-form-item__label
    color: #fff
  .login >>> .el-input__inner
    background: none
    color: #fff
  .login
    position: relative
    width: 100%
    height: 100%
    background-color: #2c2e31
    background-size: 100% 100%
    .form_container
      max-width: 7.4rem
      height: 4.2rem
      position: absolute
      top: -20%
      left: 0
      right: 0
      bottom: 0
      margin: auto
      padding: .5rem
      border-radius: .1rem
      text-align: center
      .title
        font-family: "Microsoft YaHei"
        font-weight: bold;
        font-size: .52rem
        color: #fff
    .loginForm
      margin-top: .4rem
      padding: .4rem
      border-radius: .1rem
      .submit_btn
        width: 100%
</style>



// WEBPACK FOOTER //
// src/pages/Login.vue